export const getOptions = (options: Record<string, string>) =>
  Object.entries(options).map(([value, label]) => ({ value, label }));
